export default __webpack_public_path__ + "static/media/ep14.e4048220.jpeg";